import * as React from "react";
const SvgSimulationLive20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 16,
        fill: "black",
        viewBox: "0 0 20 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m7.801 11.151.07.043-1.11 1.665-.017-.01C5.108 11.831 4 10.05 4 8c0-2 1.056-3.746 2.63-4.775L7.783 4.86C6.694 5.546 6 6.706 6 8c0 1.301.701 2.467 1.801 3.151Zm-2.212 2.915.247.18-1.11 1.666-.315-.23A9.488 9.488 0 0 1 .5 8 9.488 9.488 0 0 1 4.411.317l.11-.08 1.153 1.635-.085.062A7.488 7.488 0 0 0 2.5 8a7.488 7.488 0 0 0 3.089 6.066Zm10 1.617-.314.229-1.11-1.666.246-.18A7.488 7.488 0 0 0 17.5 8a7.49 7.49 0 0 0-3.089-6.066l-.085-.062L15.479.238l.11.08A9.489 9.489 0 0 1 19.5 8a9.488 9.488 0 0 1-3.911 7.683Zm-2.333-2.834-.017.01-1.11-1.665.07-.043c1.1-.684 1.801-1.85 1.801-3.15 0-1.295-.694-2.455-1.784-3.14l1.155-1.636C14.944 4.254 16 6 16 8c0 2.049-1.108 3.83-2.744 4.85ZM10 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgSimulationLive20Px;
